// src/rtkQuery/features/services/shippingPolicy/shippingPolicy.slice.ts

import { baseApi } from '@/rtkQuery/features/services/baseApi';
import { handleAuthError } from '@/rtkQuery/lib';
import type { ShippingPolicyResponse } from '@/rtkQuery/features/models/shippingPolicy.model';
import { PRODUCT_ENDPOINTS } from '@/rtkQuery/config/products.config';

export const shippingPolicyApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getShippingPolicy: builder.query<string, void>({
      query: () => ({
        url: PRODUCT_ENDPOINTS.POST_PRODUCTS_SHIPPING_POLICY,
        method: 'POST',
      }),

      transformResponse: (response: ShippingPolicyResponse, meta) => {
        (meta as any).status = 'success';
        (meta as any).error = null;
        return response.Object.Policy;
      },

      transformErrorResponse: (response: any, meta) => {
        const errorMessage = handleAuthError({
          message: response.data?.message || response.data,
          status: response.status,
        });

        (meta as any).status = 'error';
        (meta as any).error = errorMessage;

        return {
          status: response.status,
          message: errorMessage,
          errors: response.data?.errors || {},
        };
      },

      providesTags: ['ShippingPolicy'],
    }),
  }),

  overrideExisting: false,
});

export const {
  useGetShippingPolicyQuery,
  useLazyGetShippingPolicyQuery,
} = shippingPolicyApi;
